import { useMutation } from '@tanstack/react-query'
import { updatePaymentLimit } from 'services/PaymentLimitsService'

export const useUpdatePaymentLimitMutation = () => {
  return useMutation({ mutationFn: updatePaymentLimit })
}
